import { FormValues } from '@features/users/adminPanel/components/Form/Form.types.ts';
import { FormFields } from '@features/users/adminPanel/components/FormFields/FieldTypes.ts';

export function transformUserProfilePayload(rawPayload: FormValues) {
  const { vatNumber } = rawPayload;

  return {
    ...rawPayload,
    [FormFields.VAT_NUMBER]: vatNumber.toUpperCase(),
  };
}
